import { AltaAccessSvg } from 'components/svgs/AltaAccessSvg';
import { AltaVideoSvg } from 'components/svgs/AltaVideoSvg';
import { AltaDmpSvg } from 'components/svgs/AltaDmpSvg';
import { AltaMailroomSvgBeta } from 'components/svgs/AltaMailroomSvgBeta';
import { AppSwitcherButton } from './AppSwitcherButton';

import './AppSwitcherMenu.scss';

interface AppSwitcherMenuProps {
  handleAwareLogin?(): Promise<void>;
  handleDmpLogin?(): Promise<void>;
  handleNavigateToMailroom?(): void;
  handleNavigateToAccess(): void;
}

export const AppSwitcherMenu = ({
  handleAwareLogin,
  handleDmpLogin,
  handleNavigateToMailroom,
  handleNavigateToAccess,
}: AppSwitcherMenuProps) => {
  return (
    <div className="app-switcher-menu">
      <AppSwitcherButton
        label="Access"
        gtm="app-switcher-button-access"
        onClick={handleNavigateToAccess}
        icon={<AltaAccessSvg className="app-switcher-button__icon" />}
      />
      {handleDmpLogin ? (
        <AppSwitcherButton
          label="DMP"
          gtm="app-switcher-button-dmp"
          onClick={handleDmpLogin}
          icon={<AltaDmpSvg className="app-switcher-button__icon" />}
        />
      ) : null}
      {handleNavigateToMailroom ? (
        <AppSwitcherButton
          label="Mailroom"
          gtm="app-switcher-button-mailroom"
          onClick={handleNavigateToMailroom}
          icon={<AltaMailroomSvgBeta className="app-switcher-button__icon" />}
        />
      ) : null}
      {handleAwareLogin ? (
        <AppSwitcherButton
          label="Video"
          gtm="app-switcher-button-video"
          onClick={handleAwareLogin}
          icon={<AltaVideoSvg className="app-switcher-button__icon" />}
        />
      ) : null}
    </div>
  );
};
